import GeotileFactory from './Factory'

module.exports = {
  GeotileFactory
}
